import {
  getLevelNameTextLayout,
  type LevelNameTextLayout,
} from './levelNameTextLayout';

type LevelNameTextProps = {
  /** Figma `level_name_text` — название заказа в кавычках макета. */
  text?: string;
};

const DEFAULT_TEXT = '“Спиночесалка”';

/** Baseline в SVG ≈ 75% высоты bbox (как 48/64 у «Спиночесалка»). */
function baselineY(layout: LevelNameTextLayout): number {
  return Math.round(layout.height * 0.75);
}

/**
 * Figma `level_name_text` (Group 187:9232) — Matias, white 80%.
 * Размер, позиция и font-size берутся из {@link getLevelNameTextLayout}.
 */
export function LevelNameText({ text = DEFAULT_TEXT }: LevelNameTextProps) {
  const layout = getLevelNameTextLayout(text);
  const midX = layout.width / 2;

  return (
    <svg
      className="new-delivery-texts__level-name"
      width={layout.width}
      height={layout.height}
      viewBox={`0 0 ${layout.width} ${layout.height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
      style={{
        left: layout.left,
        top: layout.top,
        width: layout.width,
        height: layout.height,
      }}
    >
      <text
        className="new-delivery-texts__level-name-text"
        textAnchor="middle"
        xmlSpace="preserve"
        style={{ fontSize: layout.fontSize }}
      >
        <tspan x={midX} y={baselineY(layout)}>
          {text}
        </tspan>
      </text>
    </svg>
  );
}
